/**
 * @file index.tsx
 *
 * @fileoverview Renders the message if the blog search hasn't found any matching blogs.
 */

import { useIntl } from 'react-intl';
import Link from 'next/link';
import { EmptyElement } from '~/vcl/molecules/02-empty';
import { Box } from '~/vcl/atoms/07-box';
import { VerticallyCentered } from '~/vcl/atoms/06-layout/01-alignment/03-vertical-align';
import { PaperIcon } from '~/vcl/icons/Paper';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import UndoAltSolidIcon from '~/vcl/icons/UndoAltSolid';

export default function BlogSearchNoResultsFound() {
  const intl = useIntl();

  return (
    <VerticallyCentered>
      <Box>
        <EmptyElement
          icon={
            <PaperIcon
              title={intl.formatMessage({
                id: 'blog_search_no_results_found_icon_title',
                defaultMessage: 'No blog entries have been found',
              })}
            />
          }
          iconWidth="300"
          iconHeight="180"
          iconColor="primary"
        >
          <Spacing />
          {intl.formatMessage({
            id: 'blog_search_no_results_found_instructions',
            defaultMessage:
              'No blogs have been found for the searched keyword.',
          })}

          <Spacing size="medium" />
          <Link href="/blog">
            <>
              <UndoAltSolidIcon
                aria-hidden="true"
                width="15"
                height="15"
                title={intl.formatMessage({
                  id: 'undo',
                  defaultMessage: 'Undo',
                })}
              />
              &nbsp;
              {intl.formatMessage({
                id: 'blog_search_no_results_found_reset',
                defaultMessage: 'Reset Search',
              })}
            </>
          </Link>
        </EmptyElement>
      </Box>
    </VerticallyCentered>
  );
}
